module.exports = __webpack_public_path__ + "newsletter/Components/PocketHitsSignup/images/publishers/logo-mentalFloss.06006c57b9c4bbeb44c0e0b6950f1f05.png";